import { OnboardingRouteRedirect } from '../../components';

export default function Step3ConnectRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-2-connect" />;
}
